import Splide from "@splidejs/splide";

class ProductList {
	constructor() {
		this.productListSliderWr = document.querySelectorAll(".jsProductListSlider");

		if (this.productListSliderWr) {
			this.productListSliderWr.forEach((slider) => {
				this.initializeProductListSlider(slider);
			});
		}
	}

	initializeProductListSlider(slider) {
		new Splide(slider, {
			isNavigation: true,
			gap: 16,
			pagination: false,
			arrows: false,
			type: "slide",
			perPage: 1,
			destroy: true,
			breakpoints: {
				1024: {
					destroy: false,
					perPage: 2,
				},
				500: {
					perPage: 1,
				},
				400: {
					perPage: 1,
				},
			},
		}).mount();
	}
}

export default ProductList;
